export const SET_NEW_NOTICE_NUMBER = "SET_NEW_NOTICE_NUMBER";
export const CLEAR_NEW_NOTICE_NUMBER = "CLEAR_NEW_NOTICE_NUMBER";
export const CREATE_CONNECTION = "CREATE_CONNECTION";
export const SET_CONNECTING_HUB = "SET_CONNECTING_HUB";
export const CONNECT_SIGNALR_HUB = "CONNECT_SIGNALR_HUB";
export const SET_NEW_HUB_CONNECTION = "SET_NEW_HUB_CONNECTION";
export const DISCONECT_HUB = "DISCONECT_HUB";
export const UPDATE_NEW_HUB_SESSION = "UPDATE_NEW_HUB_SESSION";
export const UPDATE_ORGANIZATION_INFO = "UPDATE_ORGANIZATION_INFO";